import { getApi, postApi } from "../utils/apiHelper";
import Cookies from 'js-cookie';

export const getPrintables = (params) => {
  const queryString = new URLSearchParams(params).toString();
  console.log(queryString);
  
  return getApi(`/printables/?${queryString}`);
}

export const getPrintableCategories = () => {
  return getApi('/printables/categories/list/');
}